import axios from 'axios'

class API {
  constructor () {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_API
    })
    this.instance.defaults.headers.post['Content-Type'] = 'application/json'
  }

  // PUBLIC

  async fetchAllEvents (page) {
    let res = await this.instance.get('/?page=' + page)
    return res
  }

  // EVENT

  async fetchEvent (eventSlug) {
    let res = await this.instance.get(`/${eventSlug}`)
    return res
  }

  async fetchDataForEvent (eventSlug, from = null) {
    let url = `/${eventSlug}/data`
    if (from != null) url += '?from=' + from
    let res = await this.instance.get(url)
    return res
  }

  async fetchRace (eventSlug, raceId, sex) {
    let res = await this.instance.get(`/${eventSlug}/${raceId}/${sex}`)
    return res
  }
}

export default new API()
